import {getSearchTerm} from '../utils/searchQuery.mjs';

export default defineNuxtRouteMiddleware(to => {
	if (!Array.isArray(to.query.search_q)) return;

	return navigateTo({
		path: to.path,
		query: {...to.query, search_q: getSearchTerm(to.query.search_q) || undefined},
		hash: to.hash,
	}, {replace: true, redirectCode: 302});
});
